var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-navigation-drawer",
    {
      ref: "navDrawer",
      attrs: { fixed: "", temporary: "", clipped: "", width: 320 },
      on: { transitionend: _vm.onDrawerTransitionEnd },
      scopedSlots: _vm._u(
        [
          !_vm.isPremiumUser
            ? {
                key: "append",
                fn: function () {
                  return [
                    _c("v-divider", {}),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column pa-2 pa-md-3" },
                      [
                        _vm.isGuestUser || !_vm.isPremiumUser
                          ? _c(
                              "v-btn",
                              {
                                staticClass:
                                  "font-weight-bold mb-2 focus-buttons",
                                attrs: {
                                  block: "",
                                  color: "accent2",
                                  role: "button",
                                  "aria-button": "Go to Subscribe button",
                                  href: _vm.getRoute("pricing_page"),
                                },
                              },
                              [
                                _vm._v(
                                  "\n                Subscribe\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("start-free-trial", {
                          attrs: { outlined: "", color: "black" },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              }
            : null,
        ],
        null,
        true
      ),
      model: {
        value: _vm.menuVisible,
        callback: function ($$v) {
          _vm.menuVisible = $$v
        },
        expression: "menuVisible",
      },
    },
    [
      _c("v-list", { attrs: { dense: "" } }, [
        _c(
          "ul",
          { staticClass: "list-none pl-0" },
          [
            _c(
              "li",
              [
                _c(
                  "v-subheader",
                  {
                    staticClass:
                      "text--secondary font-weight-bold d-flex justify-space-between px-5 py-6",
                  },
                  [
                    _c("div", [_vm._v("CODES")]),
                    _vm._v(" "),
                    _c(
                      "v-icon",
                      {
                        ref: "closeButton",
                        staticClass: "focus-buttons",
                        attrs: {
                          "aria-label": "Close the side menu",
                          tabindex: "0",
                        },
                        on: { click: _vm.closeMenu },
                      },
                      [
                        _vm._v(
                          "\n                            mdi-close\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("ul", { staticClass: "list-none pl-0" }, [
                  _c(
                    "li",
                    [
                      _vm.isLoggedIn
                        ? _c(
                            "v-list-item",
                            {
                              staticClass: "focus-buttons",
                              attrs: {
                                href: _vm.getRoute("dashboard_landing"),
                                "aria-label": "Go to Dashboard",
                              },
                            },
                            [
                              _c(
                                "v-list-item-icon",
                                [
                                  _c("v-icon", [
                                    _vm._v("mdi-view-dashboard-outline"),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Dashboard"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "v-list-group",
                        {
                          staticClass: "focus-list-group",
                          attrs: {
                            "prepend-icon": "mdi-text-box-multiple-outline",
                            "no-action": "",
                            eager: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function () {
                                return [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Codes"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-none pl-0" },
                            _vm._l(_vm.codeItems, function (item, index) {
                              return _c(
                                "li",
                                [
                                  _c(
                                    "v-list-item",
                                    {
                                      key: index,
                                      staticClass:
                                        "list-item-with-left-padding focus-buttons",
                                      attrs: {
                                        href: item.link,
                                        "aria-label": `Go to ${item.title}`,
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(_vm._s(item.title)),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "v-list-item",
                        {
                          staticClass: "focus-buttons",
                          attrs: {
                            href: _vm.searchRoute,
                            "aria-label": "Go to Search",
                          },
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            [_c("v-icon", [_vm._v("mdi-magnify")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-list-item-title", [_vm._v("Search")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _vm.isLoggedIn
                        ? _c(
                            "v-list-group",
                            {
                              staticClass: "focus-list-group",
                              attrs: {
                                "prepend-icon": "mdi-bookmark-multiple-outline",
                                "append-icon": "mdi-chevron-down",
                                eager: "",
                                "no-action": _vm.isPremiumUser,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function () {
                                      return [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v("Notes"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                2032701355
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "list-none pl-0" },
                                _vm._l(_vm.userNotes, function (item, index) {
                                  return _c(
                                    "li",
                                    { key: index },
                                    [
                                      !item.hideForEnterprise
                                        ? _c(
                                            "v-list-item",
                                            {
                                              staticClass:
                                                "list-item-with-left-padding focus-buttons",
                                              attrs: {
                                                "aria-label": `Go to ${item.title}`,
                                                href: _vm.isPremiumUser
                                                  ? item.link
                                                  : "",
                                                "data-tippy": _vm.isPremiumUser
                                                  ? ""
                                                  : "Premium subscription required",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-list-item-content",
                                                [
                                                  _c(
                                                    "v-list-item-title",
                                                    {
                                                      class: _vm.isPremiumUser
                                                        ? ""
                                                        : "grey--text text--lighten-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                " +
                                                          _vm._s(item.title) +
                                                          "\n                                            "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              !_vm.isPremiumUser
                                                ? _c(
                                                    "v-list-item-action",
                                                    [
                                                      _c(
                                                        "v-avatar",
                                                        {
                                                          attrs: {
                                                            size: "24",
                                                            color:
                                                              "primaryLight",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-lock-open-variant-outline"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }),
                                0
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "v-subheader",
                  {
                    staticClass:
                      "text--secondary font-weight-bold px-5 pt-8 pb-6",
                  },
                  [_vm._v("CODE INTELLIGENCE")]
                ),
                _vm._v(" "),
                _c("ul", { staticClass: "list-none pl-0" }, [
                  _c(
                    "li",
                    [
                      _c(
                        "v-list-item",
                        {
                          staticClass: "focus-buttons",
                          attrs: {
                            href: _vm.getRoute(
                              _vm.isPremiumUser
                                ? "ai_navigator"
                                : "features_ai_navigator"
                            ),
                            "aria-label": "Go to AI Navigator",
                          },
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            [_c("v-icon", [_vm._v("mdi-navigation-outline")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-list-item-title", [_vm._v("AI Navigator")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "v-list-item",
                        {
                          staticClass: "focus-buttons",
                          attrs: {
                            href: _vm.getRoute("quick_consult"),
                            "aria-label": "Go to Quick Consult",
                          },
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", [
                                _vm._v("mdi-comment-account-outline"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-title",
                            [
                              _vm._v(
                                "Quick Consult\n                                "
                              ),
                              _c(
                                "v-chip",
                                {
                                  staticClass: "ml-2 primary--text cp",
                                  attrs: { small: "", color: "primaryLight" },
                                },
                                [
                                  _vm._v(
                                    "\n                                    New\n                                "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "v-list-item",
                        {
                          staticClass: "focus-buttons",
                          attrs: {
                            href: _vm.getRoute("premium_answers"),
                            "aria-label": "Go to Q&A Database",
                          },
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            [_c("v-icon", [_vm._v("mdi-forum-outline")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-list-item-title", [_vm._v("Q&A Database")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "v-list-item",
                        {
                          staticClass: "focus-buttons",
                          attrs: {
                            href: _vm.getRoute("compliance_calculators"),
                            "aria-label": "Go to Compliance Calculators",
                          },
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", [
                                _vm._v("mdi-calculator-variant-outline"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-list-item-title", [
                            _vm._v("Compliance Calculators"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _vm.isLoggedIn
              ? [
                  _c(
                    "li",
                    [
                      _c(
                        "v-list-item",
                        {
                          staticClass: "mt-2 focus-buttons",
                          attrs: { "aria-label": "Go to Favorites" },
                        },
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c(
                                "v-list-item-title",
                                {
                                  staticClass:
                                    "text--secondary font-weight-bold",
                                },
                                [_vm._v("FAVORITES")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list-item-action",
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "focus-buttons",
                                  attrs: {
                                    role: "button",
                                    icon: "",
                                    small: "",
                                    href: _vm.getRoute("favorites_landing"),
                                    "data-tippy": "Manage Favorites",
                                    "aria-label": "Click on Manage Favorites",
                                  },
                                },
                                [_c("v-icon", [_vm._v("mdi-cog-outline")])],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("ul", { staticClass: "list-none pl-0" }, [
                        _c(
                          "li",
                          [
                            _vm.favoriteTitles.length === 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text--secondary text-sm px-4 py-0",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                Add titles to your favorites to access them here\n                            "
                                    ),
                                  ]
                                )
                              : _vm._l(
                                  _vm.favoriteTitles,
                                  function (item, index) {
                                    return _c(
                                      "v-list-item",
                                      {
                                        key: index,
                                        staticClass:
                                          "fav-title-item focus-buttons",
                                        attrs: {
                                          href: item?.title?.link,
                                          "aria-label": `Go to ${item.title.display_title}`,
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                _vm._s(item.title.display_title)
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                          ],
                          2
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "li",
              [
                _c(
                  "v-subheader",
                  {
                    staticClass:
                      "text--secondary font-weight-bold px-5 pt-8 pb-6",
                  },
                  [_vm._v("LEARN MORE")]
                ),
                _vm._v(" "),
                _c("ul", { staticClass: "list-none pl-0" }, [
                  _c(
                    "li",
                    [
                      _c(
                        "v-list-group",
                        {
                          staticClass: "focus-list-group",
                          attrs: {
                            "prepend-icon": "mdi-creation",
                            "append-icon": "mdi-chevron-down",
                            "no-action": "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function () {
                                return [
                                  _c(
                                    "v-list-item-content",
                                    [
                                      _c("v-list-item-title", [
                                        _vm._v("Features & Pricing"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "list-none pl-0" },
                            _vm._l(
                              _vm.featuresMenuItems,
                              function (item, index) {
                                return _c(
                                  "li",
                                  [
                                    _c(
                                      "v-list-item",
                                      {
                                        key: index,
                                        staticClass:
                                          "list-item-with-left-padding focus-buttons",
                                        attrs: {
                                          href: item.link,
                                          "aria-label": `Go to ${item.title}`,
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(_vm._s(item.title)),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "v-list-item",
                        {
                          staticClass: "focus-buttons",
                          attrs: {
                            href: _vm.getRoute("concurrent-access"),
                            "aria-label": "Go to Solutions for Teams",
                          },
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            [
                              _c("v-icon", [
                                _vm._v("mdi-account-group-outline"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-list-item-title", [
                            _vm._v("Solutions for Teams"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    [
                      _c(
                        "v-list-item",
                        {
                          staticClass: "focus-buttons",
                          attrs: {
                            href: _vm.getRoute("user_exams"),
                            "aria-label": "Go to Exams",
                          },
                        },
                        [
                          _c(
                            "v-list-item-icon",
                            [_c("v-icon", [_vm._v("mdi-school-outline")])],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-list-item-title", [_vm._v("Exams")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }